var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload"},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"240","height":"180","margin":"16","accept":"image/jpeg,image/png","size":"12","button-class":"btn"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }